import { render, staticRenderFns } from "./FeeOnlyCategorization.vue?vue&type=template&id=aff9f312&"
import script from "./FeeOnlyCategorization.vue?vue&type=script&lang=ts&"
export * from "./FeeOnlyCategorization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports